import { Button, Icon_CheckmarkFilled60 } from "@shapr3d/frontend-lib";

import useTranslation from "../../hooks/useTranslation";
import { Modal } from "../../lib/modal";

import style from "./TwoFactorEnabledModal.module.css";

export type TwoFactorEnabledModalProps = {
  open: boolean;
  onClose: () => void;
};

export default function TwoFactorEnabledModal({ open, onClose }: TwoFactorEnabledModalProps) {
  const { t, m } = useTranslation();
  return (
    <Modal
      open={open}
      telemetryName="two_factor_setup_success"
      onClose={onClose}
      size="medium"
      title={t(m.TwoFactorAuth.EnabledModal.Title)}
      persistent
      footer={
        <div className={style.footer}>
          <Button variant="primary" onClick={onClose}>
            {t(m.TwoFactorAuth.EnabledModal.Ok)}
          </Button>
        </div>
      }
    >
      <div className={style.container}>
        <Icon_CheckmarkFilled60 className={style.icon} />

        <div className={style.content}>
          <p className={style.description}>{t(m.TwoFactorAuth.EnabledModal.Description)}</p>
        </div>
      </div>
    </Modal>
  );
}
